/* @flow */

import React from "react";
import { withRouter } from "react-router";
import styles from "./styles.scss";
import cn from "classnames";
import CartIcon from "icons/cart.svg";
import { QuoteData } from "data";
import { useData } from "crustate/react";
import { useTranslate } from "@awardit/react-use-translate";
import { Button } from "@crossroads/ui-components";

type Props = {
  className: string,
  location: { pathname: string },
  isOpen: boolean,
  openMiniCart: () => void,
  history: {
    push: (path: string) => void,
    goBack: () => void,
  },
};

const CartCounter = ({ className = "", location, history, isOpen, openMiniCart }: Props) => {
  const data = useData(QuoteData);
  const t = useTranslate();
  const onCheckout = location.pathname.includes("/checkout");
  const cartCount = data.data ?
    data.data.items.reduce((a, { qty }) => a + qty, 0) :
    0;

  const ariaLabelInfo = () => {
    if (!onCheckout) {
      return isOpen ?
        t("CART.NAV_BUTTON_CLOSE", { count: cartCount }) :
        t("CART.NAV_BUTTON_OPEN", { count: cartCount });
    }

    return t("CART.NAV_BUTTON_CART", { count: cartCount });
  };

  if (cartCount > 0) {
    return (
      <Button
        type="button"
        aria-controls="cartMini"
        aria-label={ariaLabelInfo()}
        aria-expanded={isOpen ?? "false"}
        className={cn(
          styles.block,
          { [styles.active]: onCheckout || isOpen },
          className
        )}
        onClick={() => {
          if (onCheckout) {
            history.goBack();
          }
          else if (cartCount) {
            openMiniCart();
          }
          else {
            history.push("/checkout");
          }
        }}
      >
        <div>
          <span className={styles.count}>
            <span>
              {cartCount}
            </span>
          </span>
          <CartIcon aria-label={t("ICONS.CART")} />
        </div>
      </Button>
    );
  }

  return (
    <div className={cn(styles.block, className)}>
      <CartIcon aria-label={t("ICONS.CART")} />
    </div>
  );
};

export default withRouter(CartCounter);
